import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterActions'
})
export class FilterActionsPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( it => {
    return it.action_name.toLowerCase().includes(searchText);
    });
   }


}
